import { useState } from 'react'
import { DEFAULT_COLUMNS } from '../pages/Settings'

const COLUMN_LABELS = {
  product_id:'Product ID', product_name:'Product Name',
  sourcing_cost_usd:'Sourcing Cost (USD)', sourcing_cost_eur:'Sourcing Cost (€)',
  shipping_cost_usd:'Shipping Cost (USD)', shipping_cost_eur:'Shipping Cost (€)',
  assets_status:'Assets', readiness:'Readiness',
  assigned_to:'Assignee',
  total_cogs:'Total COGs (€)', profit_margin:'Profit Margin (%)', selling_price_eur:'Selling Price (€)',
  aliexpress_link:'Sourcing Link',
  comp_adv_html:'Comp Adv HTML',
  comp_sales_html:'Comp Sales HTML', deadline:'Deadline',
  shopify_fee:'Shopify Fee', currency_conv:'Currency Conv (2%)',
  total_fees:'Total Fees (€)', profit:'Profit (€)', be_roas:'BE ROAS',
  competitor_product_url:'Competitor Product URL', competitor_advertorial_url:'Advertorial URL', competitor_page_ad_url:'Competitor Page Ad URL',
  competitor_winning_ad_links:'Competitor Winning Ad Links',
  competitor_ad_copy_primary:'Comp Ad Copy Primary', competitor_ad_copy_headline:'Comp Ad Copy Headline',
  competitor_ad_creative_link:'Comp Creative Link', offer_to_use:'Offers (per market)',
  research_notes:'Your Recommendations',
  platform_found_on:'Platform Found On', competitor_price:'Competitor Price', ad_running_duration:'Ad Running Duration', ad_countries:'Countries Running In', scale_signal:'Scale Signal', ad_hook:'Ad Hook', ad_angle:'Angle Used', market_saturated:'Market Saturated?', desire_targeted:'Desire Targeted', customer_concerns:'Customer Concerns', problem_addressed:'Problem Addressed', target_audience:'Target Audience', competitor_positioning:'Key Competitor Positioning',
  market:'Market', reference_ad_link:'Winning Ad Ref', creative_type:'Type', quantity:'Qty', brief:'Brief', priority:'Priority', delivered_link:'Delivered Link', requested_by:'Requested By', advertorial_link:'Advertorial Link', content_ready:'Content', readiness:'Readiness',
  funnel_link:'Funnel Link', brand_name:'Brand Name', funnel_status:'Work Status',
  completed:'Completed', approval:'Approval', creative_file_link:'Creative File/Link',
  creative_status:'Work Status', assigned_editor:'Assigned Editor',
  revision_notes:'Revision Notes', ai_copy_primary:'AI Copy — Primary',
  ai_copy_headline:'AI Copy — Headline', status:'Status', approved_by:'Approved By',
  ad_account:'Ad Account', page:'Page', campaign_name:'Campaign Name', daily_budget_eur:'Daily Budget (€)',
  scheduled_date:'Scheduled Date', campaign_status:'Campaign Status',
  date_added_as_winner:'Date Added as Winner', last_creative_added_date:'Last Creative Date',
  comments:'Comments',
}

const COLUMNS_VERSION = 'v36' // bump this when adding new columns to force cache reset

export function useColumns(section) {
  const key = `cols_${section}`
  const versionKey = `cols_version_${section}`
  const [cols, setCols] = useState(() => {
    try {
      const savedVersion = localStorage.getItem(versionKey)
      const saved = localStorage.getItem(key)
      // If version mismatch, use defaults merged with saved (new columns get default visibility)
      if (savedVersion !== COLUMNS_VERSION || !saved) {
        const merged = { ...DEFAULT_COLUMNS[section] }
        localStorage.setItem(versionKey, COLUMNS_VERSION)
        localStorage.setItem(key, JSON.stringify(merged))
        return merged
      }
      // Merge saved with defaults so new columns always appear
      return { ...DEFAULT_COLUMNS[section], ...JSON.parse(saved) }
    } catch { return { ...DEFAULT_COLUMNS[section] } }
  })

  function toggle(col) {
    setCols(prev => {
      const updated = { ...prev, [col]: !prev[col] }
      localStorage.setItem(key, JSON.stringify(updated))
      return updated
    })
  }

  function reset() {
    const def = { ...DEFAULT_COLUMNS[section] }
    localStorage.setItem(key, JSON.stringify(def))
    setCols(def)
  }

  const isVisible = col => cols[col] !== false
  return { cols, isVisible, toggle, reset }
}

export function ColumnPicker({ section, cols, toggle, reset }) {
  const [open, setOpen] = useState(false)

  return (
    <div style={{position:'relative'}}>
      <button className="btn btn-secondary btn-sm" onClick={() => setOpen(o => !o)}>
        ⚙ Columns
      </button>

      {open && (
        <>
          {/* Backdrop */}
          <div style={{position:'fixed',inset:0,zIndex:99}} onClick={() => setOpen(false)} />

          {/* Dropdown */}
          <div style={{
            position:'absolute',right:0,top:'calc(100% + 6px)',zIndex:100,
            background:'#fff',border:'1px solid #E2E8F0',borderRadius:12,
            boxShadow:'0 8px 30px rgba(0,0,0,0.12)',padding:16,width:280,
          }}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
              <span style={{fontSize:13,fontWeight:700,color:'#0D1B2A'}}>Show / Hide Columns</span>
              <button onClick={() => { reset(); }} style={{
                fontSize:11,color:'#1E6FBF',background:'none',border:'none',cursor:'pointer',fontWeight:600
              }}>Reset</button>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:4,maxHeight:360,overflowY:'auto'}}>
              {Object.entries(cols).map(([col, visible]) => (
                <div key={col} onClick={() => toggle(col)} style={{
                  display:'flex',alignItems:'center',gap:10,padding:'7px 10px',
                  borderRadius:8,cursor:'pointer',
                  background:visible?'#EFF6FF':'transparent',
                  transition:'background 0.15s'
                }}>
                  {/* Toggle switch */}
                  <div style={{
                    width:32,height:18,borderRadius:9,flexShrink:0,
                    background:visible?'#1E6FBF':'#CBD5E1',
                    position:'relative',transition:'background 0.2s'
                  }}>
                    <div style={{
                      position:'absolute',top:2,
                      left:visible?14:2,
                      width:14,height:14,borderRadius:'50%',
                      background:'#fff',transition:'left 0.2s'
                    }}/>
                  </div>
                  <span style={{fontSize:13,color:'#374151'}}>{COLUMN_LABELS[col] || col}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  )
}
